export const setGarageSelected = garage => localStorage.setItem('garage_selected', garage)
export const getGarageSelected = () => localStorage.getItem('garage_selected')
export const deleteGarageSelected = () => localStorage.removeItem('garage_selected')